import styled, { css } from 'styled-components';
import { Text, Link } from '../Typography';
import theme from '../theme';
import Select from '../Select';

export const StyledContainer = styled.div<{ $singleColumn?: boolean }>`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-column-gap: 15px;
  grid-row-gap: 17px;

  ${({ $singleColumn }) => $singleColumn && `grid-template-columns: 1fr;`}
`;

export const StyledAttachmentPanel = styled.a<{
  $error?: boolean;
  href: string;
}>`
  border: 1px solid ${({ $error }) => ($error ? theme.red6 : theme.gray5)};
  border-radius: ${theme.getBorderRadius('medium')};
  position: relative;
  display: grid;
  grid-template-columns: 1fr 15px;
  width: 100%;
  cursor: ${({ href }) => (href ? 'pointer' : 'initial')};
`;

export const StyledCloseButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  line-height: 0;
  padding: 10px;
`;

export const StyledGrid = styled.div`
  padding: 15px;
  display: grid;
  grid-template-columns: 23px 1fr auto;
  gap: 0 15px;
  justify-content: flex-start;
  align-items: center;
  .text-wrapper {
    display: grid;
    overflow: hidden;
  }
`;

const fileNameMixin = css`
  font-size: 14px;
  line-height: 22px;
`;

export const StyledFileNameText = styled(Text)`
  ${fileNameMixin}
`;

export const StyledFileNameLink = styled(Link)`
  ${fileNameMixin}
`;

export const StyledFileSize = styled(Text)<{ $error?: boolean }>`
  font-size: 12px;
`;

export const StyledProgress = styled.div<{
  $hidden?: boolean;
  $width: number;
}>`
  background-color: ${theme.getColor('primary')};
  height: 3px;
  transition: all 1s;
  opacity: ${({ $hidden }) => ($hidden ? 0 : 1)};
  width: ${({ $width }) => $width}%;
  grid-column-end: span 2;
`;
